/*
 * PDP metafield fill.
 * On /collections/<collection>/products/<handle> URLs, Shopify renders the product
 * template with product.metafields empty (the collection request context drops them),
 * so the skin-concerns / key-ingredients / how-to-use / ingredients blocks come back empty.
 * The canonical /products/<handle> page renders them fine, so when we detect an empty
 * [data-mf-block] we fetch the canonical page once and copy the block HTML in.
 * On /products/ URLs the blocks are already filled, so nothing runs.
 */
(() => {
  const blocks = Array.from(document.querySelectorAll('[data-mf-block]'));
  if (!blocks.length) return;

  const facets = document.querySelector('[data-mf-block="facets"]');
  const handle = facets && facets.getAttribute('data-mf-handle');
  if (!handle) return;

  const isEmpty = (el) => el.children.length === 0;
  const emptyBlocks = blocks.filter(isEmpty);
  if (!emptyBlocks.length) return; // already rendered server-side (canonical URL)

  // Only meaningful inside a collection-scoped URL; on a bare /products/ URL an empty
  // block just means the product genuinely has no data, so skip the extra request.
  if (!/\/collections\/[^/]+\/products\//.test(location.pathname)) return;

  fetch('/products/' + encodeURIComponent(handle), { credentials: 'same-origin' })
    .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      let injected = false;
      emptyBlocks.forEach((el) => {
        const key = el.getAttribute('data-mf-block');
        const src = doc.querySelector('[data-mf-block="' + key + '"]');
        if (src && src.children.length) {
          el.innerHTML = src.innerHTML;
          injected = true;
        }
      });
      if (injected) {
        // Re-bind accordions for any How-to-Use / Ingredients we just injected.
        document.dispatchEvent(new Event('sora:accordions:init'));
      }
    })
    .catch(() => {});
})();
